import { jsxs as l, jsx as e } from "react/jsx-runtime";
function i(C) {
  return /* @__PURE__ */ l(
    "svg",
    {
      width: "62",
      height: "61",
      viewBox: "0 0 62 61",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...C,
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M61.2057 20.3732L31.177 10.6053C31.1132 10.5839 31.0431 10.5839 30.9788 10.6053L0.796722 20.2243C0.663818 20.2671 0.573254 20.3898 0.571795 20.5291C0.570325 20.6688 0.658446 20.793 0.789891 20.8382L8.16392 23.365V32.1202C6.92583 32.6762 6.06268 33.9173 6.06268 35.3623C6.06268 36.8073 6.92684 38.0493 8.16392 38.6044L6.2252 51.0892H12.6879L11.0725 38.6044C12.3106 38.0488 13.1737 36.8073 13.1737 35.3623C13.1737 33.9173 12.3105 32.6762 11.0725 32.1202V24.3611L30.8698 31.1446C30.9034 31.1563 30.9389 31.1621 30.974 31.1621C31.009 31.1621 31.0446 31.1568 31.0782 31.1451L61.2091 20.9872C61.3416 20.9424 61.4297 20.8182 61.4287 20.6795C61.4273 20.5393 61.3377 20.4166 61.2057 20.3732H61.2057Z",
            fill: "rgb(var(--text-primary))"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M30.3448 32.6736C30.5468 32.7427 30.7571 32.7788 30.9709 32.7788L30.9707 32.7788C31.1835 32.7788 31.3943 32.7453 31.5944 32.6766L47.8558 27.1946L47.856 32.4866C47.2868 32.3887 46.7016 32.3377 46.1044 32.3377C40.4374 32.3377 35.8434 36.9317 35.8434 42.5987C35.8434 43.2254 35.8996 43.839 36.0072 44.4347C34.4896 44.5954 32.8808 44.6818 31.2148 44.6818C22.0236 44.6818 14.5732 42.0537 14.5732 38.8116V27.27L30.3448 32.6736Z",
            fill: "rgb(var(--text-primary))"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M55.9797 43.4498C55.9797 48.4093 51.9593 52.4297 46.9999 52.4297C42.0404 52.4297 38.02 48.4093 38.02 43.4498C38.02 38.4904 42.0404 34.47 46.9999 34.47C51.9593 34.47 55.9797 38.4904 55.9797 43.4498ZM45.9615 48.2046L52.6239 41.5421C52.8502 41.3159 52.8502 40.9491 52.6239 40.7228L51.8046 39.9035C51.5784 39.6773 51.2116 39.6773 50.9853 39.9035L45.5518 45.337L43.015 42.8002C42.7888 42.574 42.422 42.574 42.1957 42.8002L41.3764 43.6195C41.1502 43.8458 41.1502 44.2126 41.3764 44.4388L45.1421 48.2046C45.3684 48.4309 45.7352 48.4309 45.9615 48.2046Z",
            fill: "rgb(var(--text-primary))"
          }
        )
      ]
    }
  );
}
export {
  i as HatWithCheck
};
